/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isArrayLike.js
// module id = 293
// module chunks = 0